import { Timestamp } from '@/types/api.types';

export const formatDate = (dateString: string | Timestamp | undefined) => {
  if (!dateString) return '-';
  if (typeof dateString === 'string') {
    return new Date(dateString).toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return new Date(dateString).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Format date with optional timezone.
 * Uses lecture tz when provided (show in device timezone), otherwise UTC so stored time is shown as-is.
 */
export const formatDateAsYearMonthDayHourMinute = (
  dateString: string | Timestamp | undefined,
  timeZone?: string
) => {
  if (!dateString) return '-';
  const opts: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...(timeZone ? { timeZone } : { timeZone: 'UTC' }),
  };
  const date = typeof dateString === 'string' ? new Date(dateString) : new Date(dateString);
  return date
    .toLocaleString('es-ES', opts)
    .replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2})/, '$3/$2/$1 $4:$5');
};
